import { keys } from "../../../function/object";
import * as E from "../../either";
import { blindLookup, fromValidate, validate, } from "../validated";
import { validationException, validationExceptionMany, } from "../validation-exception";
import * as RNEA from "fp-ts/ReadonlyNonEmptyArray";
const rightMerge = (e1, e2) => E.ap(E.map((r1) => (r2) => (Object.assign(Object.assign({}, r1), r2)), e1), e2);
const decorateValidationException = (k) => (e) => validationException(`Validation failure for entry "${String(k)}" in record.`, e);
/**
 * Validator for validating to a record with all key-value pair to a specific type.
 * Will validate until the first key-value pair validation exception appears. Faster than `recordall`
 * but will not contain every error in the validation exception
 */
export const record = (r) => fromValidate((x) => {
    if (typeof x === "object" && x !== null) {
        const ks = keys(r);
        let result = E.of({});
        for (const k of ks) {
            // Validate the value with its corresponding validated via `key`
            const val = validate(r[k], blindLookup(k, x));
            // If validation failed, return with immediately with validation error
            if (E.is.Left(val)) {
                return E.first(decorateValidationException(k), val);
            }
            // If validated, merge its validated value into the record and continue
            else {
                result = rightMerge(result, E.map((v) => ({ [k]: v }), val));
            }
        }
        return result;
    }
    else {
        return E.left(validationException(`Expected value to be of type object, it has type ${typeof x}`));
    }
});
/**
 * Validator for validating to a record with all key-value pair to a specific type.
 * Will validate all key-value pairs before returning.
 */
export const recordAll = (r) => fromValidate((x) => typeof x === "object" && x !== null
    ? E.first((exceptions) => validationExceptionMany("Record validation failed", exceptions), keys(r).reduce((e, k) => rightMerge(e, E.map((v) => ({ [k]: v }), E.first((e) => RNEA.of(decorateValidationException(k)(e)), validate(r[k], blindLookup(k, x))))), E.of({})))
    : E.left(validationException(`Expected value to be of type object, it has type ${typeof x}`)));
/**
 * Allows for creating some record with arbitrary keys and value is of Validated<A>
 *
 * @param a Is a validator that validates all values in record to A
 * @return A validated record with all values validated to A
 */
export const someRecord = (a) => fromValidate((x) => typeof x === "object" && x !== null
    ? E.first((exceptions) => validationExceptionMany("Some record validation failed", exceptions), Object.entries(x)
        .map(([k, v]) => [
        k,
        E.first((e) => RNEA.of(decorateValidationException(k)(e)), validate(a, v)),
    ])
        .reduce((e, [k, e2]) => rightMerge(e, E.map((v2) => ({ [k]: v2 }), e2)), E.of({})))
    : E.left(validationException(`Expected value to be of type object, it has type ${typeof x}`)));

